"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_PAGE_LIMIT = void 0;
var DEFAULT_PAGE_LIMIT = 50;
exports.DEFAULT_PAGE_LIMIT = DEFAULT_PAGE_LIMIT;